
import { defineComponent, PropType } from 'vue'
import { EnterpriseGroup } from '~/types/types'
import { formatDate, parseISODate } from '~/utils/date'

interface EnterpriseGroupWithCounts extends EnterpriseGroup {
  teamsCount: {
    totalCount: number
  }
  membersCount: {
    totalCount: number
  }
}

export default defineComponent({
  name: 'ControlPanelGroupHeader',
  props: {
    group: {
      type: Object as PropType<EnterpriseGroupWithCounts>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    parseISODate,
    formatDate,
    refetchData() {
      this.$emit('refetch')
    }
  }
})
